import React, { PureComponent } from 'react';
import Lozenge from 'ak-lozenge';

export default class PlatformLozenge extends PureComponent {
  render() {
    const { platform } = this.props;
    return platform ? (
      <Lozenge
        appearance={platform === 'React' ? 'new' : 'moved'}
      >{platform}</Lozenge>
    ) : <span>&nbsp;</span>;
  }
};



// WEBPACK FOOTER //
// ./src/components/ComponentIndexPage/PlatformLozenge.jsx